import axios from 'axios'

const filesApiAxios = axios.create({
  baseURL: 'https://files.tyhacz.com',
  headers: {
    'x-api-key': 'public_QC2VvVUQVj3nHPGLwWya5rL6Ag9Rb8LocuenDQ7DfseE0AAWexJYCse193w1IlND'
  }
})

export const uploadFile = async (file: File, onProgress?: (progress: number) => void): Promise<{ url: string }> => {
  const formData = new FormData()
  formData.append('file', file)

  const response = await filesApiAxios.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress) {
        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        onProgress(progress)
      }
    }
  })

  return response.data
}
